import React, { useEffect, useState } from 'react';
import { Loading, Error, useNotify } from 'react-admin';
import {
  Box, IconButton
} from '@material-ui/core';
import {
  ListAlt as ListAltIcon
} from '@material-ui/icons';
import { useQuery } from '../util/locationHelper';
import {
  firstDateOfMonth, getYearMonthDate, 
  getPrevMonthDay, getNextMonthDay, getYearMonth
} from '../calendar'

import { reqSettle, reqPatchMemo } from './api';
import SettlementInfo from './SettlementInfo';
import SettlementCalendar from "./SettlementCalendar";
import SupplierListDialog from "./SupplierListDialog";
import { presentAdjustSum } from './functions';

// query params 에 공급사 정보 없는 경우 
const defaultSupplier = { id: 2, name: '고피자' };

const SupplierCalendar = ({ }) => {

  const notify = useNotify();
  
  const { query, updateQuery } = useQuery();

  const [ firstDate, setFirstDate ] = useState(firstDateOfMonth(new Date()));
  const [ data, setData ] = useState();
  const [ loading, setLoading ] = useState(false);
  const [ error, setError ] = useState();
  const [ openDlgSuppliers, setOpenDlgSuppliers ] = useState(false);

  const supplier = query.id ? query : defaultSupplier;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: result } = await reqSettle(supplier.id, firstDate);
        setData(result);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
        // LATER: server logging 
        console.error(err);
      }
    }

    fetchData();
  }, [ query, firstDate ]);

  const handleClickPrev = () => {
    setFirstDate(getPrevMonthDay(firstDate));
  };

  const handleClickNext = () => {
    setFirstDate(getNextMonthDay(firstDate));
  }

  const handleSaveMemo = async (date, memo) => {
    try {
      // patch data 
      const result = await reqPatchMemo(supplier.id, date, memo);
      // check result 

      // reload 
      setFirstDate(getNextMonthDay(getPrevMonthDay(firstDate)));
    } catch (err) {
      console.error(err);
      notify(`저장에 실패했습니다. 관리자에게 문의해주세요. \n오류: ${err}`, 'error');
    }
  }

  const handleClickSupplierList = () => {
    setOpenDlgSuppliers(true);
  }

  const handleClose = () => {
    setOpenDlgSuppliers(false);
  }

  const handleSelect = supplier => {
    setOpenDlgSuppliers(false);
    updateQuery(supplier);
  }

  const yearMonth = getYearMonth(firstDate);
  const downloadUrl = `${process.env.REACT_APP_FCS_API_URL}/purchase-orders/download?supplierId=${supplier.id}&yearMonth=${yearMonth}`;
  const downloadName = `${supplier.name}-${yearMonth}.xlsx`;

  if (loading || !data) return <Loading />;
  if (error) return <Error error={error} />;

  const { 
    sellAmount, fee, adjust, calculated, orderQty, kpi 
  } = data.total ?? {};

  return (
    <div>
      <h1>
        공급자 정산
      </h1>
      {/* actions */}
      <div>
        <div>
          <span>{supplier.name}</span>
          <IconButton
            aria-label="change supplier"
            onClick={handleClickSupplierList}
          >
            <ListAltIcon />
          </IconButton>
        </div>
        <Box
          display="flex"
        >
          <SettlementInfo title='총 매출' value={sellAmount} />
          <SettlementInfo title='총 수수료' value={fee} />
          <SettlementInfo title='조정액' value={adjust ? presentAdjustSum(adjust) : ''} />
          <SettlementInfo title='총 정산액' value={calculated} />
          <SettlementInfo title='총 식수량' value={orderQty} />
          <SettlementInfo title='KPI' value={kpi} />
          <div>
            <a href={downloadUrl} download={downloadName}>명세서 다운로드</a>
          </div>
        </Box>
      </div>
      {/* calendar */}
      <div>
        <SettlementCalendar 
          firstDate={firstDate}
          data={data}
          onClickPrev={handleClickPrev}
          onClickNext={handleClickNext}
          onSaveMemo={handleSaveMemo}
        />
      </div>
      <SupplierListDialog
        open={openDlgSuppliers}
        onClose={handleClose}
        onSelect={handleSelect}
      />
    </div>
  )
}

export default SupplierCalendar;